import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import GenericFormDrawer from '../../../components/GenericFormDrawer';
import { REVIEW_STATUSES, saveReview } from './config';

// Analiz E08 / §29 — toplantı öncesi inceleme notu: durum (bekliyor / incelendi / görüşülecek), kanıt incelendi işareti ve not.
// Puan DEĞİŞTİRMEZ. Okunan sürümle gönderilir (expectedVersion): araya başka yazım girdiyse sunucu 409 döner, ilk değişiklik
// üzerine yazılmaz; çekmece açık kalır (tost interceptor'da), kullanıcı güncel notu yeniden açar.
export default function ReviewDrawer({ sessionId, target, onClose, onSaved }) {
  const { t } = useTranslation();
  const schema = useMemo(() => [
    {
      name: 'status', label: t('performance.calibrationWorkspace.review.status'), type: 'select', required: true, grid: 12,
      options: REVIEW_STATUSES.map((s) => ({ id: s, name: t(`performance.calibrationWorkspace.reviewStatus.${s}`) })),
    },
    { name: 'evidenceReviewed', label: t('performance.calibrationWorkspace.evidenceReviewed'), type: 'checkbox', grid: 12 },
    { name: 'note', label: t('performance.calibrationWorkspace.review.note'), type: 'textarea', grid: 12, maxLength: 4000 },
    { name: 'hint', type: 'notice', grid: 12, content: t('performance.calibrationWorkspace.review.hint') },
  ], [t]);

  const initial = useMemo(() => (target ? {
    status: target.reviewStatus || 'pending',
    evidenceReviewed: !!target.evidenceReviewed,
    note: target.reviewNote || '',
  } : undefined), [target]);

  return (
    <GenericFormDrawer
      open={!!target}
      onClose={onClose}
      title={target ? t('performance.calibrationWorkspace.review.title', { name: target.employeeName }) : ''}
      schema={schema}
      initialValues={initial}
      submitLabel={t('performance.calibrationWorkspace.review.save')}
      onSave={async (values) => {
        const saved = await saveReview(sessionId, target.recordId, {
          status: values.status || 'pending',
          note: values.note || null,
          evidenceReviewed: !!values.evidenceReviewed,
          expectedVersion: target.reviewVersion ?? 0,
        });
        if (!saved) return false;
        onSaved?.(saved);
        return true;
      }}
    />
  );
}
